// extracted by mini-css-extract-plugin
export default {"l_Label_main":"Label_l_Label_main__U38jw"};